/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RolesManagementModule} from './roles-management/roles-management.module';
import {SettingsRoutingModule} from './settings-routing.module';
import {BusinessSettingsModule} from './business-settings/business-settings-tree/business-settings.module';
import {CountryModalModule} from './business-settings/shared/country-modal/country-modal.module';
import {PartnerModalModule} from './business-settings/shared/partner-modal/partner-modal.module';
import {ShipToPartyModalModule} from './business-settings/shared/ship-to-party-modal/ship-to-party-modal.module';
import {ReasonModalModule} from './business-settings/shared/reasons-modal/reason-modal.module';
import {
    SupplyingPackingPlantModalModule
} from './business-settings/shared/supplying-packing-plant-modal/supplying-packing-plant-modal.module';
import {TransportModeModalModule} from './business-settings/shared/transport-mode-modal/transport-mode-modal.module';
import {
    TransportServiceModalModule
} from './business-settings/shared/transport-service-modal/transport-service-modal.module';
import {LeadTimeModalModule} from './business-settings/shared/lead-time-modal/lead-time-modal.module';
import {ClaimCodeModalModule} from './business-settings/shared/claim-code-modal/claim-code-modal.module';
import {DecisionCodeModalModule} from './business-settings/shared/decision-code-modal/decision-code-modal.module';
import {ErrorCodeModalModule} from './business-settings/shared/error-code-modal/error-code-modal.module';
import {WarningModalModule} from './business-settings/shared/warning-modal/warning-modal.module';
import {
    BusinessSettingsMainPageModule
} from './business-settings/business-settings-main-page/business-settings-main-page.module';
import {
    BusinessCategoryModalModule
} from './business-settings/shared/business-category-modal/business-category-modal.module';
import {
    TechnicianGroupModalModule
} from './business-settings/shared/technician-group-modal/technician-group-modal.module';
import {AlertsMainPageModule} from './alerts/alerts-main-page/alerts-main-page.module';

@NgModule({
    imports: [
        CommonModule,
        SettingsRoutingModule,
        RolesManagementModule,
        BusinessSettingsModule,
        BusinessSettingsMainPageModule,
        CountryModalModule,
        PartnerModalModule,
        ShipToPartyModalModule,
        SupplyingPackingPlantModalModule,
        TransportModeModalModule,
        TransportServiceModalModule,
        LeadTimeModalModule,
        WarningModalModule,
        ReasonModalModule,
        ClaimCodeModalModule,
        DecisionCodeModalModule,
        ErrorCodeModalModule,
        BusinessCategoryModalModule,
        TechnicianGroupModalModule,
        AlertsMainPageModule
    ]
})

export class SettingsModule {
}

